import { useQuery } from '@tanstack/react-query';

import { resolveSubscription } from '../api/subscription';

type UseResolveMarketplaceTokenResult = {
  subscriptionId?: string;
  isLoading: boolean;
  isError: boolean;
};

export const useResolveMarketplaceToken = (
  msalToken?: string,
  marketplaceToken?: string,
): UseResolveMarketplaceTokenResult => {
  const query = useQuery({
    enabled: !!msalToken && !!marketplaceToken,
    queryKey: ['resolveMarketplaceToken', marketplaceToken?.slice(0, 10)],
    queryFn: () => (msalToken && marketplaceToken ? resolveSubscription({ msalToken, marketplaceToken }) : undefined),
    retry: false, // Don't retry on error - show error immediately
  });

  return {
    subscriptionId: query.data?.data.subscription.id,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
